import { render } from "./PrintInvoiceInfoDesign1.vue?vue&type=template&id=67c51ffb&scoped=true"
import script from "./PrintInvoiceInfoDesign1.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceInfoDesign1.vue?vue&type=script&lang=js"

import "./PrintInvoiceInfoDesign1.vue?vue&type=style&index=0&id=67c51ffb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c51ffb"]])

export default __exports__